import { WebhookSettingsForm } from './webhook-settings';
import { TransactionsFilteringForm } from '@/routes/trackings/components/transactions-filtering-form';
import { useNavigate, useParams } from 'react-router-dom';
import { useState, useMemo, useCallback } from 'react';
import {
  DestinationTrackingDetails,
  createSetupNavigator
} from '../../components/destination-tracking-details';

export const WebhookTrackingDetails = ({ isSetup = false }: { isSetup: boolean }) => {
  const navigate = useNavigate();
  const { tab: tabFromParams = 'webhook-settings', id } = useParams<{
    tab: string;
    id: string;
  }>();

  const [displayTabs, setDisplayTabs] = useState([
    {
      label: 'Webhook Settings',
      value: 'webhook-settings',
      disabled: false,
      setupCompleted: false
    },
    {
      label: 'Transactions',
      value: 'transactions',
      disabled: true,
      setupCompleted: false
    }
  ]);

  const [activeTab, setActiveTab] = useState(tabFromParams || displayTabs[0].value);

  const handleTabChange = useCallback(
    (newTabValue: string) => {
      setActiveTab(newTabValue);
      void navigate(`../integrations/${id!}/${newTabValue}`, { replace: true, state: { isSetup } });
    },
    [navigate, id, isSetup, setActiveTab]
  );

  const navigateToNextStep = useMemo(
    () =>
      createSetupNavigator(
        () => displayTabs,
        () => activeTab,
        setDisplayTabs,
        handleTabChange
      ),
    [displayTabs, activeTab, handleTabChange]
  );

  const handleNonSetupContinue = useCallback(() => {
    // TODO: FIX LOGIC SO EMPTY FUNCTION IS NOT NEEDED
  }, []);

  const onContinue = isSetup ? navigateToNextStep : handleNonSetupContinue;

  const content = [
    {
      key: 'webhook-settings',
      content: <WebhookSettingsForm onContinue={onContinue} />
    },
    {
      key: 'transactions',
      content: (
        <TransactionsFilteringForm isLastTab={true} onContinue={onContinue} isSetup={isSetup} />
      )
    }
  ];

  return (
    <>
      <DestinationTrackingDetails
        displayTabs={displayTabs}
        isSetup={isSetup}
        activeTab={activeTab}
        onTabChange={handleTabChange}
        id={id!}
        content={content}
      />
    </>
  );
};
